import apiClient from "./client";

// Fetch list of eKYC cases visible to the logged-in client
export const getCases = () => apiClient.get("/api/client/cases");

// Fetch a single case's full details, reusing the same data the
// admin dashboard shows (admin.js / adminCaseProfile.js) but
// simplified into layman-friendly labels on the frontend.
export const getCaseDetails = (caseId) =>
  apiClient.get(`/api/client/cases/${caseId}`);

export const getCaseProfile = (caseId) =>
  apiClient.get(`/api/client/cases/${caseId}/profile`);
